
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/contexts/AuthContext';
import { OptimizedHotelProvider } from '@/contexts/OptimizedHotelContext';

import { ThemeProvider } from '@/components/theme/ThemeProvider';
import { Toaster } from '@/components/ui/toaster';
import { HotelRouter } from '@/components/routing/HotelRouter';
import { useScheduledCacheReset } from '@/hooks/useScheduledCacheReset';
import { useVersionCheck } from '@/hooks/useVersionCheck';
import { useCacheResetNotification } from '@/hooks/useCacheResetNotification';
import { ErrorBoundary } from '@/components/ui/error-boundary';

// Оптимизированная конфигурация QueryClient для ЭТАП 7
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      staleTime: 5 * 60 * 1000, // 5 минут
      gcTime: 10 * 60 * 1000, // 10 минут
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 2,
      retryDelay: (attemptIndex) => Math.min(500 * 2 ** attemptIndex, 10000),
    },
  },
});

function AppContent() {
  useScheduledCacheReset();
  useVersionCheck();
  useCacheResetNotification();
  
  return (
    <>
      <HotelRouter />
      <Toaster />
    </>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <OptimizedHotelProvider>
            {/* RealtimeProvider перенесён в AdminLayout — виджет работает без WebSocket */}
            <ThemeProvider defaultTheme="system" storageKey="hotel3d-ui-theme">
              <Router>
                <AppContent />
              </Router>
            </ThemeProvider>
          </OptimizedHotelProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
